class KfProductInformationAccordion extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick, true);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick, true);
  }

  #handleClick = (event) => {
    if (this.dataset.preservePosition !== 'true') return;

    const summary = event.target.closest('summary');
    if (!summary || !this.contains(summary)) return;

    const details = summary.parentElement;
    if (!(details instanceof HTMLDetailsElement) || details.open) return;

    const openDetails = this.querySelector('details[open]');
    if (!openDetails || openDetails === details) return;

    const startingTop = summary.getBoundingClientRect().top;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reduceMotion ? 80 : 500;
    const startedAt = performance.now();

    const preservePosition = () => {
      if (!this.isConnected) return;

      const currentTop = summary.getBoundingClientRect().top;
      const difference = currentTop - startingTop;

      if (Math.abs(difference) > 0.5) {
        window.scrollBy(0, difference);
      }

      if (performance.now() - startedAt < duration) {
        requestAnimationFrame(preservePosition);
      }
    };

    requestAnimationFrame(preservePosition);
  };
}

if (!customElements.get('kf-product-information-accordion')) {
  customElements.define('kf-product-information-accordion', KfProductInformationAccordion);
}
